export const ArPartyOptions = ({placeholder = 'All parties'}) => {
  const parties = useArParties().sort((a, b) => a.name.localeCompare(b.name))

  return pug`
    option(value='')= placeholder
    for party in parties
      option(key=party.id value=party.id)= party.name
  `
}
